import axiosInterceptor from '../helpers/axiosInterceptor';
import { GET_EXPERT_PACKAGE_LIST } from "../Constants";

function getExpertPackageList() {
      return axiosInterceptor.get(GET_EXPERT_PACKAGE_LIST);
}

export default getExpertPackageList;